module.exports = __webpack_public_path__ + "img/car-pool-parking.8a0a2d0b.png";